"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturesService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("../../shared/services/restservice");
const http_1 = require("@angular/common/http");
const rxjs_1 = require("rxjs");
class FeaturesService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.featuresUrl = '/rest-api/account/v1/myFeatures';
        this.addRemoveFeatureUrl = '/rest-api/account/v1/business/feature/update';
        this.submitOrderFeatureUrl = '/rest-api/cart/services/v1/feature';
        this.eupDetailsUrl = '/rest-api/earlyUpgrade/v1/eupDetails';
    }
    getFeatures(cacheResponse) {
        if (this.featureDetails && cacheResponse === true) {
            return rxjs_1.of(this.featureDetails);
        }
        else {
            this.featureDetails = null;
            return this.get(this.featuresUrl).pipe(operators_1.map((data) => {
                this.featureDetails = data;
                return data;
            }));
        }
    }
    // B2B bulk add feature
    b2bAddRemoveBulkFeature(subscrptionList, updateType) {
        const inputArgs = new http_1.HttpParams().set('subIds', subscrptionList).set('updateType', updateType);
        return this.post(this.addRemoveFeatureUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    submitOrderFeature(subId, featureId, enable) {
        const inputArgs = new http_1.HttpParams().set('subscriptionId', subId).set('featureId', featureId).set('enable', enable.toString());
        return this.post(this.submitOrderFeatureUrl, inputArgs).pipe(operators_1.map((data) => data));
    }
    getEUPDetails() {
        return this.get(this.eupDetailsUrl).pipe(operators_1.map((data) => data));
    }
    getNWAuthorizedFeat(activeFeatureList) {
        if (activeFeatureList && activeFeatureList.length > 0) {
            for (const fn of activeFeatureList) {
                if (fn.featureServiceName === 'NW_AUTHORIZED_FEAT') {
                    return true;
                }
            }
        }
        return false;
    }
}
exports.FeaturesService = FeaturesService;
//# sourceMappingURL=features.services.js.map